import React from "react";
import { withRouter } from "react-router-dom";
import { ProSidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { FiShoppingBag } from "react-icons/fi";
import { BsBoxSeam, BsPersonCircle, BsInfoCircle } from "react-icons/bs";

import { RxDashboard } from "react-icons/rx";
import { IoHomeOutline, IoCreateOutline } from "react-icons/io5";
import { IoMdImages } from "react-icons/io";
import { SlLogin } from "react-icons/sl";
import { VscFeedback } from "react-icons/vsc";

import handloom_logo from "../../assets/handloom_logo.png";
import "./custom.scss";
import "./sidebar_styles.css";


const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    paritialVisibilityGutter: 0
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
    paritialVisibilityGutter: 75
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    paritialVisibilityGutter: 75
  }
};

class SideBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sideBar: this.props.sideBarShow
    };
  }
  toggleButton = () => {
    this.setState({
      sideBar: !this.state.sideBar,
    });
  };
  navigateTo = (pageName) => {
    this.props.history.push(pageName);
    this.toggleButton()
  }
  navigateToEcommerce = () => {
    window.open("https://tradikart.nielitkohima.in/", '_blank')
    this.toggleButton()
  }
  render() {
    return (
      <>
        {
          this.state.sideBar?
            <ProSidebar>
              <center>
                <img src={handloom_logo} style={{ height: 120, marginTop:"17%", marginBottom: "10%" }} />
              </center>
              <Menu iconShape="square" className="sidebar-icons-margin">
                <MenuItem icon={<IoHomeOutline size={26} color={"#fff"} style={{marginRight: 7}}/>}>
                  <span onClick={() => this.navigateTo("/")} className="sidebar-item-txt">Home</span>
                </MenuItem>
                <MenuItem icon={<BsInfoCircle size={26} color={"#fff"} style={{marginRight: 7}}/>}>
                  <span onClick={() => this.navigateTo("/about")} className="sidebar-item-txt">About</span>
                </MenuItem>
                <MenuItem icon={<RxDashboard size={25} color="white" style={{marginRight: 7}}/>}>
                  <span onClick={() => this.navigateTo("/dashboard")} className="sidebar-item-txt">Dashboard</span>
                </MenuItem>
                
                <MenuItem icon={<IoMdImages size={27} color={"#fff"} style={{marginRight: 7}}/>}>
                  <span onClick={() => this.navigateTo("/media")} className="sidebar-item-txt">Media</span>
                </MenuItem>
                <MenuItem icon={<VscFeedback size={27} color={"#fff"} style={{marginRight: 7}}/>}>
                  <span onClick={() => this.navigateTo("/add-feedback")} className="sidebar-item-txt">Feedbacks</span>
                </MenuItem>
                <MenuItem icon={<FiShoppingBag size={27} color={"#fff"} style={{marginRight: 7}}/>}>
                  <span onClick={this.navigateToEcommerce} className="sidebar-item-txt">E-Commerce</span>
                </MenuItem>
                <center>
                <hr className="sidebar_hr_white"/>
                </center>
                <MenuItem icon={<SlLogin size={23} color={"#fff"} style={{marginRight: 7}}/>}>
                  <span onClick={() => this.navigateTo("/login")} className="sidebar-item-txt">Login</span>
                </MenuItem>
                <MenuItem icon={<BsPersonCircle size={25} color={"#fff"} style={{marginRight: 7}}/>}>
                  <span onClick={() => this.navigateTo("/register")} className="sidebar-item-txt">Register</span>
                </MenuItem>
                <div className="empty-sidebar-div"></div>
              </Menu>
            </ProSidebar>
          :
            <></>
        }
      </>
    );
  }
}

export default withRouter(SideBar);
